<div #container class="flex items-center" [class.nsp-carryover-joined]="showHistoryButton()">
  <div class="min-w-0 flex-1">
    <ng-content />
  </div>

  @if (showHistoryButton()) {
    <button
      pButton
      type="button"
      [disabled]="isButtonDisabled()"
      [pTooltip]="tooltipText()"
      tooltipPosition="top"
      aria-label="Use previous report value"
      data-testid="carryover-history-button"
      (mouseenter)="onHoverEnter()"
      (mouseleave)="onHoverLeave()"
      (click)="onHistoryClick()"
      class="w-10.5 rounded-l-none border border-l-0 border-(--p-inputtext-border-color) bg-(--p-inputtext-background)"
      [style.cursor]="isButtonDisabled() ? 'not-allowed' : 'pointer'"
    >
      <fa-icon [icon]="historyIcon" />
    </button>
  }
</div>
